<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <form class="modal-content" v-on:submit.prevent="submit">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Add Sales Invoice</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div v-show="step === 0">
                        <div class="block-content fs-sm">
                            <div class="mb-4">
                                <label class="form-label" for="f_vehicle">Vehicle (required)</label>
                                <select class="form-select" id="f_vehicle" ref="vehiclePicker" style="width:100%"></select>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button @click="timeEntriesSelect" :disabled="chosenVehicle === null" type="button" class="btn btn-sm btn-success">
                                Next
                            </button>
                        </div>
                    </div>
                    <div v-show="step === 1">
                        <div class="block-content fs-sm">
                            <p>Please select the time entries that you would like to invoice.</p>
                            <!-- load datatables with time entries -->
                            <table ref="time-entries-table" class="table table-bordered table-striped table-vcenter dataTable sales-invoice-table" style="width:100%;">
                                <thead>
                                    <tr>
                                        <th>Add To Invoice</th>
                                        <th>Job</th>
                                        <th>Total Time</th>
                                        <th>Hourly Labour Rate</th>
                                        <th>Total Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <div class="my-4" v-if="timeEntryResellTotals !== null">
                                <table class="table table-bordered table-striped table-vcenter">
                                    <thead>
                                        <tr>
                                            <th>Total Time</th>
                                            <th>Total Cost</th>
                                            <th>Resell Rate</th>
                                            <th>Resell Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-end">
                                            <td>{{ timeEntryResellTotals.time }}</td>
                                            <td>&pound;{{ timeEntryResellTotals.cost }}</td>
                                            <td>&pound;{{ timeEntryResellTotals.resellRate }}</td>
                                            <td>&pound;{{ timeEntryResellTotals.value }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="my-4">
                                <label class="form-label" for="f_vehicle">Select tax rate:</label>
                                <template>
                                    <select v-model="timeEntriesTaxType" class="form-select" style="width:100%;">
                                        <option v-for="activeTaxRate in activeTaxRates" :value="activeTaxRate.tax_type">{{ activeTaxRate.text }}</option>
                                    </select>
                                </template>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button @click="back" type="button" class="btn btn-sm btn-alt-secondary me-1">
                                Back
                            </button>
                            <button @click="purchaseInvoicesSelect" type="button" class="btn btn-sm btn-success">
                                Next
                            </button>
                        </div>
                    </div>
                    <div v-show="step === 2">
                        <div class="block-content fs-sm">
                            <p>Please select the parts that you would like to add to the sales invoice.</p>
                            <table ref="purchase-invoices-table" class="table table-bordered table-striped table-vcenter dataTable sales-invoice-table">
                                <thead>
                                    <tr>
                                        <th>Add To Invoice</th>
                                        <th>Supplier Name</th>
                                        <th>Purchase Invoice Number</th>
                                        <th>Invoice Date</th>
                                        <th>Net Total</th>
                                        <th>VAT Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                            <div class="my-4">
                                <label class="form-label" for="f_vehicle">Select tax rate:</label>
                                <template>
                                    <select v-model="purchaseInvoicesTaxType" class="form-select" style="width:100%;">
                                        <option v-for="activeTaxRate in activeTaxRates" :value="activeTaxRate.tax_type">{{ activeTaxRate.text }}</option>
                                    </select>
                                </template>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button @click="back" type="button" class="btn btn-sm btn-alt-secondary me-1">
                                Back
                            </button>
                            <button @click="preview" type="button" class="btn btn-sm btn-success">
                                Preview
                            </button>
                        </div>
                    </div>
                    <div>
                        <div :disabled="noTimeEntriesChecked && noInvoicesChecked" v-show="step === 3">
                            <div class="block-content fs-sm">
                                <table class="table table-bordered table-striped table-vcenter sales-invoice-table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th>
                                                <strong>Net Total</strong>
                                            </th>
                                            <th>
                                                <strong>VAT Total</strong>
                                            </th>
                                            <th>
                                                <strong>Total Cost</strong>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <strong>Labour</strong>
                                            </td>
                                            <td>Total Time: {{ timeEntriesTotalDuration }}</td>
                                            <td>&#163;{{ timeEntriesNetTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ timeEntriesVatTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ timeEntriesTotal.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Parts</strong>
                                            </td>
                                            <td></td>
                                            <td>&#163;{{ purchaseInvoicesNetTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ purchaseInvoicesVatTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ purchaseInvoicesTotal.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Consumables</strong>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="consumablesPercentage">
                                                    <span class="input-group-text">%</span>
                                                </div>
                                            </td>
                                            <td>&#163;{{ consumablesNetTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ consumablesVatTotal.toFixed(2) }}</td>
                                            <td>&#163;{{ consumablesTotal.toFixed(2) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="4" class="text-end">
                                                <strong>Grand Total</strong>
                                            </td>
                                            <td colspan="2" class="text-end">
                                                <strong>&#163;{{ (grandTotal + consumablesTotal).toFixed(2) }}</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="col-xl-4 mb-4">
                                    <label  class="form-label" for="invoice-datepicker">Invoice Date:</label>
                                    <input type="text" class="form-control js-flatpickers" placeholder="Y-m-d" name="invoice-datepicker" data-date-format="d/m/Y" v-model="invoiceDate"/>
                                </div>
                            </div>
                            <div class="block-content block-content-full text-end bg-body">
                                <button @click="back" type="button" class="btn btn-sm btn-alt-secondary me-1">
                                    Back
                                </button>
                                <button @click="create" type="button" class="btn btn-sm btn-success">
                                    Create
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

const inPounds = (data) => '&pound;' + data;

export default {
    props: {
        routes: Object,
        vehicleUuid: {
            type: String,
            required: false,
        },
        taxRates: {
            type: Array,
            required: true,
        },
        consumableRate: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            step: 0,
            chosenVehicle: null,
            errors: [],
            modal: null,
            timeEntryResellTotals: null,
            excludedTimeEntries: [],
            excludedPurchaseInvoices: [],
            datatable: null,
            timeEntriesDatatableRoute: null,
            purchaseInvoicesDatatable: null,
            purchaseInvoicesDatatableRoute: null,
            vehicleName: null,
            timeEntriesNetTotal: 0,
            timeEntriesVatTotal: 0,
            timeEntriesTotal: 0,
            timeEntriesTotalDuration: null,
            purchaseInvoicesNetTotal: 0,
            purchaseInvoicesVatTotal: 0,
            purchaseInvoicesTotal: 0,
            grandTotal: 0,
            noInvoicesChecked: false,
            noTimeEntriesChecked: false,
            invoiceLineItems: [],
            activeTaxRates: [],
            timeEntriesTaxType: null,
            purchaseInvoicesTaxType: null,
            consumablesPercentage: 0,
            invoiceDate: null
        };
    },
    computed: {
        consumablesNetTotal () {
            return (this.timeEntriesNetTotal + this.purchaseInvoicesNetTotal) * (this.consumablesPercentage / 100);
        },
        consumablesVatTotal () {
            return this.consumablesNetTotal * .2;
        },
        consumablesTotal () {
            return this.consumablesNetTotal + this.consumablesVatTotal;
        },
    },
    mounted () {
        this.activeTaxRates = JSON.parse(JSON.stringify(this.taxRates));
        this.modal = new Modal(this.$el);
        this.invoiceDate = new Date().toLocaleDateString();
        this.consumablesPercentage = this.consumableRate;
        if (this.vehicleUuid) {
            this.chosenVehicle = this.vehicleUuid;
            this.timeEntriesSelect();
        }

        Eventbus.on('add-classics-salesinvoice', () => {
            this.errors = [];
            this.timeEntries = [];
            this.purchaseInvoices = [];
            this.modal.show();
        });

        setTimeout(() => {
            window.jQuery(this.$refs.vehiclePicker).select2({
                dropdownParent: this.$el,
                placeholder: 'Select vehicle',
                ajax: {
                    cache: true,
                    data: function(params) {
                        return {
                            search: params.term,
                            page: params.page
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function(data) {
                        return {
                            results: data.data
                        };
                    },
                    url: this.routes.selectVehicleRoute,
                }
            }).on('select2:select', (ev) => {
                this.chosenVehicle = ev.params.data.id;
                this.vehicleName = ev.params.data.text;
            });
        });
    },
    watch: {
        timeEntriesDatatableRoute(newValue) {
            // we can't reinitialise the datatable and we can't create a datatable with a null URL so
            if (this.datatable === null) {
                const table = this.$refs['time-entries-table'];

                let columns = [
                    {
                        data: 'uuid',
                        render: (data) => {
                            if (this.excludedTimeEntries.indexOf(data) !== -1) {
                                return "<input type='checkbox' name='time_entries[]' value='" + data + " '/>";
                            }

                            return "<input type='checkbox' name='time_entries[]' value='" + data + "' checked />";
                        },
                    },
                    {
                        data: 'description',
                    },
                    {
                        data: 'duration',
                        orderable: false,
                    },
                    {
                        data: 'cost_rate',
                        render: inPounds,
                    },
                    {
                        data: 'cost_amount',
                        render: inPounds,
                    },
                ];

                this.datatable = window.jQuery(table).DataTable({
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: newValue,
                    },
                    order: [[0, 'desc']],
                    columns: columns,
                    lengthMenu: [25, 50],
                });

                window.jQuery(table).on('change', 'input', (ev) => {
                    let timeEntryID = ev.target.getAttribute('value');
                    let alreadyExcluded = this.excludedTimeEntries.indexOf(timeEntryID) !== -1;

                    if (ev.target.checked === false) {
                        // if the unchecked value exists in the array, skip
                        if (alreadyExcluded) {
                            return;
                        }

                        // otherwise, add the item to the excluded array
                        this.excludedTimeEntries.push(timeEntryID);
                    // if the value is checked now, but was previously unchecked
                    } else if (alreadyExcluded) {
                        // get the index of the value and remove it from the array
                        this.excludedTimeEntries.splice(this.excludedTimeEntries.indexOf(timeEntryID), 1);
                    }

                    this.getTimeEntryResellTotal();
                });
            } else {
                this.datatable.ajax.url(newValue).load();
            }

            this.getTimeEntryResellTotal();
        },

        purchaseInvoicesDatatableRoute(newValue) {
            // we can't reinitialise the datatable and we can't create a datatable with a null URL so
            if (this.purchaseInvoicesDatatable === null) {
                const purchaseInvoicesTable = this.$refs['purchase-invoices-table'];

                let columns = [
                    {
                        data: 'guid',
                        render: (data) => {
                            if (this.excludedPurchaseInvoices.indexOf(data) !== -1) {
                                return "<input type='checkbox' name='purchase_invoices[]' value='" + data + " '/>";
                            }

                            return "<input type='checkbox' name='purchase_invoices[]' value='" + data + "' checked />";
                        },
                    },
                    {
                        data: 'supplier_name',
                    },
                    {
                        data: 'number',
                    },
                    {
                        data: 'date',
                    },
                    {
                        data: 'net_total',
                        render: inPounds,
                    },
                    {
                        data: 'vat_total',
                        render: inPounds,
                    },
                ];

                this.purchaseInvoicesDatatable = window.jQuery(purchaseInvoicesTable).DataTable({
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: newValue,
                    },
                    order: [[0, 'desc']],
                    columns: columns,
                    lengthMenu: [10, 25],
                });

                window.jQuery(purchaseInvoicesTable).on('change', 'input', (ev) => {
                    let purchaseInvoiceID = ev.target.getAttribute('value');
                    let alreadyExcluded = this.excludedPurchaseInvoices.indexOf(purchaseInvoiceID) !== -1;

                    if (ev.target.checked === false) {
                        // if the unchecked value doesn't exist in the array, skip
                        if (alreadyExcluded) {
                            return false;
                        }

                        // otherwise, add the item to the excluded array
                        this.excludedPurchaseInvoices.push(purchaseInvoiceID);

                    // if the value is checked now, but was previously unchecked
                    } else if (alreadyExcluded) {
                        // get the index of the value and remove it from the array
                        this.excludedPurchaseInvoices.splice(this.excludedPurchaseInvoices.indexOf(purchaseInvoiceID), 1);
                    }
                });
            } else {
                this.purchaseInvoicesDatatable.ajax.url(newValue).load();
            }
        }

    },
    methods: {
        timeEntriesSelect: function () {
            this.setDefaultVat();
            this.step++;
            this.timeEntriesDatatableRoute = this.routes.vehicleTimeEntriesRoute.replace('replace-me', this.chosenVehicle);
        },
        back: function () {
            this.step--;
            if (this.step === 0) {
                this.chosenVehicle = null;
                this.timeEntries = [];
                this.purchaseInvoices = [];
                window.jQuery(this.$refs.vehiclePicker).val(null).trigger('change');
            }
        },
        purchaseInvoicesSelect: function() {
            this.step++;
            this.purchaseInvoicesDatatableRoute = this.routes.vehiclePurchaseInvoicesRoute.replace('replace-me', this.chosenVehicle);
        },
        getTimeEntryResellTotal: function() {
            axios.post(this.routes.vehicleTimeEntriesResellRoute.replace('replace-me', this.chosenVehicle), {
                excludedTimeEntries: this.excludedTimeEntries,
            }).then((response) => {
                this.timeEntryResellTotals = response.data;
            });
        },
        setDefaultVat() {
            axios.get(this.routes.vehicleOwnershipRoute.replace('replace-me', this.chosenVehicle)).then((response) => {
                if (response.data == 'Fleet') {
                    const noVatTaxRate = this.activeTaxRates.find((element, index) => {
                            if (element['tax_type'] == 'NONE') {
                                return index;
                            };
                        }
                    );
                    this.timeEntriesTaxType = noVatTaxRate['tax_type'];
                    this.purchaseInvoicesTaxType = noVatTaxRate['tax_type'];
                } else {
                    let defaultTaxRate = this.activeTaxRates.filter( data => data.isDefault === true)[0]['tax_type'];
                    this.timeEntriesTaxType = defaultTaxRate;
                    this.purchaseInvoicesTaxType = defaultTaxRate;
                }
            });
        },
        preview: function() {
            axios.post(this.routes.draftInvoiceRoute, {
                excludedPurchaseInvoices: this.excludedPurchaseInvoices,
                excludedTimeEntries: this.excludedTimeEntries,
                vehicleUuid: this.chosenVehicle,
                timeEntriesTaxType: this.timeEntriesTaxType,
                purchaseInvoicesTaxType: this.purchaseInvoicesTaxType,
                makeAnInvoice: false
            }).then((response) => {
                this.noTimeEntriesChecked = response.data.noTimeEntriesChecked;
                this.noInvoicesChecked = response.data.noInvoicesChecked;
                if (this.noTimeEntriesChecked === true && this.noInvoicesChecked === true) {
                    this.step--;
                    this.back();
                    Swal.fire({
                        icon: 'error',
                        text: 'You must select at least 1 time entry and/or 1 consumable part to create an invoice!',
                    });
                } else {
                    this.step++;
                    this.timeEntriesNetTotal = response.data.timeEntriesNetTotal;
                    this.timeEntriesVatTotal = response.data.timeEntriesVatTotal;
                    this.timeEntriesTotal = this.timeEntriesNetTotal + this.timeEntriesVatTotal;
                    this.timeEntriesTotalDuration = response.data.timeEntriesTotalDuration;
                    this.purchaseInvoicesNetTotal = response.data.purchaseInvoicesNetTotal;
                    this.purchaseInvoicesVatTotal = response.data.purchaseInvoicesVatTotal;
                    this.purchaseInvoicesTotal = this.purchaseInvoicesNetTotal + this.purchaseInvoicesVatTotal;
                    this.grandTotal = this.timeEntriesTotal + this.purchaseInvoicesTotal;
                    this.invoiceLineItems = this.invoiceLineItems.push(response.data.lineItems);
                }
            });
        },
        create: function() {
            axios.post(this.routes.draftInvoiceRoute, {
                excludedPurchaseInvoices: this.excludedPurchaseInvoices,
                excludedTimeEntries: this.excludedTimeEntries,
                vehicleUuid: this.chosenVehicle,
                timeEntriesTaxType: this.timeEntriesTaxType,
                purchaseInvoicesTaxType: this.purchaseInvoicesTaxType,
                consumablesPercentage: this.consumablesPercentage,
                makeAnInvoice: true,
                invoiceDate: this.invoiceDate,
            }).then((response) => {
                this.modal.hide();
                this.step = 0;
                this.timeEntries = [];
                this.purchaseInvoices = [];
                this.timeEntriesNetTotal = 0;
                this.timeEntriesVatTotal = 0;
                this.timeEntriesTotal = 0;
                this.timeEntriesTotalDuration = null;
                this.purchaseInvoicesNetTotal = 0;
                this.purchaseInvoicesVatTotal = 0;
                this.purchaseInvoicesTotal = 0;
                this.grandTotal = 0;
                this.timeEntriesTaxType = null;
                this.purchaseInvoicesTaxType = null;

                if (this.vehicleUuid === undefined) {
                    this.chosenVehicle = null;
                    window.jQuery(this.$refs.vehiclePicker).val(null).trigger('change');
                }
                Eventbus.emit('sales-invoices-table-refresh');
                Swal.fire({
                    icon: 'success',
                    text:'The Sales Invoice has been created successfully!',
                });
            }).catch((e) => {
                console.error(e);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to create the invoice',
                    text: 'There was a problem whilst trying to create the sales invoice',
                });
            });
        }
    }
}

</script>
<style lang="scss">
    // center those checkboxes
    .sales-invoice-table.dataTable {
        tbody > tr > td {
            &:first-child {
                text-align: center;
            }
        }
    }

    // we're lucky that the last three columns
    // of each table should be right aligned
    .sales-invoice-table {
        tbody > tr > td {
            &:nth-last-child(1),
            &:nth-last-child(2),
            &:nth-last-child(3) {
                text-align:right !important;
            }
        }
    }
</style>
